import React from 'react'
import { Container } from './styles'
import { Button } from '~/components/shared'
import { IconComponent } from '~/assets/icons/component'

interface ModalButtonComeBackProps {
  onClick: () => void
}

const ModalButtonComeBack = ({ onClick }: ModalButtonComeBackProps): JSX.Element => {
  return (
    <Container>
      <Button color="primary" data-testid="buttonComeBack" width="117px" onClick={() => onClick()} variant="contained">
        <div className="button">
          <IconComponent name="chevronLeft" />
          Voltar
        </div>
      </Button>
    </Container>
  )
}

export { ModalButtonComeBack }
